import React from 'react'
import { Trans } from '@lingui/macro'

import { Flex, Box, ButtonDanger } from 'front-end/src/components'

import GroupAvatar from '../../../../components/common/group/group-avatar/GroupAvatar'
import {
  useEventInvitedGroupsQuery,
  useRecurringEventInvitedGroupsQuery,
  useRemoveGroupFromSeriesInviteMutation,
  useRemoveGroupInviteMutation
} from './InvitedGroupsList.codegen'

import './InvitedGroupsList.less'
import { brandColors } from 'shared/basicPalette'
import { fontWeights } from 'front-end/src/components/chakraThemeExtension'

const InvitedGroupsList = ({
  onRemove,
  eventId,
  isRecurringSeries = false
}: {
  onRemove: (IGroupWithUserCount) => void
  eventId: number
  isRecurringSeries?: boolean
}) => {
  const [removeGroup] = isRecurringSeries
    ? useRemoveGroupFromSeriesInviteMutation()
    : useRemoveGroupInviteMutation()
  const { data, refetch } = isRecurringSeries
    ? useRecurringEventInvitedGroupsQuery({
        variables: { eventId }
      })
    : useEventInvitedGroupsQuery({
        variables: { eventId }
      })
  const groups = isRecurringSeries
    ? data?.admin?.recurringEvent?.invitedGroups
    : data?.admin?.event?.invitedGroups

  return (
    <div className="List AttendanceTab__groupsList">
      {groups?.map((group) => {
        return (
          <div key={group.id} className="ListItem">
            <Flex>
              <GroupAvatar group={group} />
              <Flex flexDirection="column">
                <Box
                  fontSize="15px"
                  fontWeight={fontWeights.bold}
                  lineHeight="20px"
                >
                  {group.name}
                </Box>

                <Box fontSize="12px" color={brandColors.grey.light}>
                  <Trans>{group.usersCount} members</Trans>
                </Box>
              </Flex>
            </Flex>

            <div className="ListItem-actions">
              <ButtonDanger
                onClick={async () => {
                  await removeGroup({
                    variables: {
                      groupId: group.id,
                      eventId
                    }
                  })
                  refetch()
                  onRemove(group)
                }}
                dataTest="RemoveGroupButton"
              >
                <Trans>Remove</Trans>
              </ButtonDanger>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default InvitedGroupsList
